import { useQuery, gql } from '@apollo/client';

export function GetDataPoints() {
  const { data = {}, loading, error } = useQuery(GET_DATAPOINTBYCUSTOMER);
  return { loading, data: data.DataPointsByCustomer || [], error };
}

const GET_DATAPOINTBYCUSTOMER = gql`
  query DataPointsByCustomer {
    DataPointsByCustomer {
      _id
      name
      customerId
      longitude
      latitude
      active
      module
      location
      time
      diameter
      threshold
      yValuesMax
      setting
    }
  }
`;
